import common from "../common";
import BaseStage from "./BaseStage";
import Dorothy from "../actors/Dorothy";
import ParticleEmitter from "../reusableModules/ParticleEmitter";
import SecondaryCharacter from "../actors/SecondaryCharacter";
import TutorialFinger from "../reusableModules/TutorialFinger";
import Dough from "./Stage_Cutting_Objects/Dough";
var dataURLtoBlob = require('blueimp-canvas-to-blob');


/**
 * Screenshot of game
 */
export default class Stage_Photo extends BaseStage {
    constructor() {
        super("photo_1", false);

        this._cookies = [];

        this._circleMask = null;

        this._text = null;
        this._screenshotButton = null;
        this._downloadButton = null;
        this._continueButton = null;
        this._retakeButton = null;

        this._frame = null;
        this._background = null;

        this._decoratedCookie = null;
        this._dorothy = null;
        this._animationChangeTimerReset = 9;
        this._animationChangeTimer = this._animationChangeTimerReset;
        this._photoTaken = false;

        this._gameContainer = null;

        this._poseButtons = [];

        this._particleEmitter = null;
        this._heartsEmitter = null;
        this._tutorialFinger = null;

        this.bindings = {};
    }

    init() {
        super.init(P3.audio.playMusic("music_final_photo_complete_screen_00"));

        this.bindings.help = this.signals.helpTutorial.add(()=>{
            this.createTutorial()
        }, this);


        this._boomBk = new PIXI.Sprite(P3.assets.texture('bg_photo'));
        this._boomBk.width = 1900;
        this._boomBk.anchor.set(0.5);
        this._boomBk.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(this._boomBk);

        this.addCharacters();

        this._text = new PIXI.extras.BitmapText("STAGE 9 \n\n(Screenshot)", {
            font: "30px VAGRounded",
            align: "center"
        });
        this._text.visible = true;
        this._text.tint = 0xEF3E5A;
        this._text.anchor.set(0.5);
        //this.addChild(this._text);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_large_off");
        states.over = P3.assets.texture("btn_primary_large_over");
        states.down = P3.assets.texture("btn_primary_large_down");
        states.icon = P3.assets.texture("icon_camera_off");

        this._screenshotButton = new P3.Button(states);
        this._screenshotButton.visible = false;
        this._screenshotButton.scale.set(0.6);
        this.addChild(this._screenshotButton);

        this._screenshotButton.signals.down.add(this.onScreenshotButtonClick, this);

        this.createFrameUI();
        this.createPoseButtons();
        this.createUI();
        this.createParticleEmitter();

        this._circleMask = new PIXI.Graphics();
        this._circleMask.beginFill(0x000000);
        this._circleMask.drawCircle(0, 0, 1600);
        this._circleMask.x = common.STAGE_WIDTH * 0.5;// - this._circleMask.width * 0.5;
        this._circleMask.y = common.STAGE_HEIGHT * 0.5;// - this._circleMask.height * 0.5;
        this.mask = this._circleMask;
        this.addChild(this._circleMask);
    };

    destroy() {
        for (const i in this.bindings) {
            if (this.bindings.hasOwnProperty(i)) {
                const binding = this.bindings[i];
                binding.detach();
            }
        }
        this.bindings = {};

        super.destroy();
    }

    resize() {
        super.resize();
        this._text.x = common.STAGE_WIDTH * 0.5;
        this._text.y = common.STAGE_HEIGHT * 0.5 - 250;

        this._screenshotButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 150;
        this._screenshotButton.y = common.STAGE_HEIGHT * 0.5 + 225;

        this._nextStageButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 150;
        this._nextStageButton.y = common.STAGE_HEIGHT * 0.5 + 225;

        this._downloadButton.x = common.STAGE_WIDTH * 0.5 - 300;
        this._downloadButton.y = common.STAGE_HEIGHT * 0.5 + 300;

        this._continueButton.x = common.STAGE_WIDTH * 0.5 + 300;
        this._continueButton.y = common.STAGE_HEIGHT * 0.5 + 300;

        this._retakeButton.x = common.STAGE_WIDTH * 0.5;
        this._retakeButton.y = common.STAGE_HEIGHT * 0.5 + 300;

        let offsetX = common.STAGE_WIDTH * 0.5 - 150;
        for (let i = 0; i < this._poseButtons.length; i++) {
            let btn = this._poseButtons[i];
            btn.position.set(offsetX, common.STAGE_HEIGHT * 0.5 + 225);
            offsetX += 150;
        }
    }

    animateIn() {
        super.animateIn();

        let self = this;
        this._screenshotButton.scale.set(0);
        let continueTween = new P3.utils.TWEEN.Tween(this._screenshotButton.scale, this.tweens)
            .to({
                x: .8,
                y: .8
            }, 340)
            .easing(P3.utils.Easing.Back3.Out)
            .yoyo(false)
            .delay(100)
            .onStart(function () {
                self._screenshotButton.visible = true;
            });
        continueTween.start();

        for (let i = 0; i < this._poseButtons.length; i++) {
            const poseButton = this._poseButtons[i];
            new P3.utils.TWEEN.Tween(poseButton.scale, this.tweens)
                .to({
                    x: .8,
                    y: .8
                }, 340)
                .easing(P3.utils.Easing.Back2.Out)
                .yoyo(false)
                .delay(100)
                .onStart(()=> {
                    poseButton.visible = true;
                })
                .start();
        }
    }

    update() {
        super.update();

        if(!this._photoTaken){
            this._dorothy.update(P3.Ticker.dt);
        }

        if(this._particleEmitter && !this._photoTaken)
            this._particleEmitter.update();

        if(this._heartsEmitter && !this._photoTaken){
            this._heartsEmitter.update();
        }
    }

    pauseGame() {
        super.pauseGame();
    }

    resumeGame() {
        super.resumeGame();
    }

    onScreenshotButtonClick() {

        if(this._tutorialFinger != null){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }

        this.bindings.help.detach();

        this._photoTaken = true;
        this._screenshotButton.visible = false;
        this._helpButton.visible = false;
        this._muteButton.visible = false;

        for (let i = 0; i < this._allCookieContainer.children.length; i++) {
            const child = this._allCookieContainer.children[i];
            child._down.stop();
            child._up.stop();
            child._move.stop();
        }
        this._secondaryCharacter._breathIn.stop();
        this._secondaryCharacter._breathOut.stop();
        this._secondaryCharacter._slideIn.stop();
        this._allCookieContainer._tween1.stop();
        this._allCookieContainer._tween2.stop();

        if(this._goldThing != null){
            this._goldThing._popIn.stop();
            this._goldThing._shimmerTween.stop();
            this._goldThing._rotateTween.stop();
            this._goldThing.alpha = 1;
        }

        for (let i = 0; i < this._poseButtons.length; i++) {
            let btn = this._poseButtons[i];
            btn.visible = false;
        }

        let tweenin = new P3.utils.TWEEN.Tween(this._circleMask.scale, this.tweens)
            .to({
                x:0 , y:0
            }, 750)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .onComplete(()=>{


                this._frame.visible = true;
                //mask
                this._frameMask = new PIXI.Sprite(PIXI.Texture.WHITE);
                this._frameMask.anchor.set(0.5);
                //console.log(this._frame.width);
                this._frameMask.width = 880;
                this._frameMask.height = 640;
                this._t.addChild(this._frameMask);
                this._gameContainer.mask = this._frameMask;

                this.animateInFrame();
                //P3.audio.playSound("sfx_btn_accept_00");

            })
            .start();

        let tweenout = new P3.utils.TWEEN.Tween(this._circleMask.scale, this.tweens)
            .to({
                x: 1, y:1
            }, 750)
            .easing(P3.utils.TWEEN.Easing.Quadratic.In);

        tweenin.chain(tweenout);
        P3.audio.playSound("sfx_take_final_photo");
    }

    createTutorial(){
        if(this._tutorialFinger != null){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }

       // console.log("yes");

        this._tutorialFinger = new TutorialFinger({x: this._screenshotButton.x + 75, y: this._screenshotButton.y}, 4, 3);
        this.addChild(this._tutorialFinger);
        this._tutorialFinger.clickDown();
        this._tutorialFinger.clickUp();
        this._tutorialFinger.play();
       // console.log(this._tutorialFinger.position);
    }

    onDownloadButtonClick(){
        if(this._tutorialFinger != null){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }
        this._continueButton.visible = false;
        this._downloadButton.visible = false;
        this._retakeButton.visible = false;
        this._text.visible = false;


        const canvas = common.renderer.extract.canvas(common.stage);
        const imgName = 'CookieMagic';

        canvas.toBlob((b) => {
            let a = document.createElement('a');

            document.body.append(a);
            a.download = imgName;
            a.href = URL.createObjectURL(b);
            a.click();
            a.remove();
        }, 'image/jpeg');

        this._continueButton.visible = true;
        this._downloadButton.visible = true;
        this._retakeButton.visible = true;
        this._text.visible = true;
    }

    onContinueButtonClick(){
        this.onNextStageButtonClick();
    }

    onRetakeButtonClick(){
        //reload scene
        this.signals.reload.dispatch();
    }

    onPoseButtonClick(poseButton){
        let self = this.parent;
        this._dorothy.playPhotoPoseAnimation(poseButton._animationID);
        P3.audio.playSound("sfx_btn_change_camera_pose_00");
    }

    recreateCookie() {
        //if(common.selectedCharacter._requestCompleted){
            this._goldThing = new PIXI.Sprite(P3.assets.texture('result_godrays'));
            this._goldThing.anchor.set(0.5);
            this._goldThing.scale.set(0);
            this._goldThing.position.set(0,-100);
            this._gameContainer.addChildAt(this._goldThing, 1);

            this._goldThing._shimmerTween = new P3.utils.TWEEN.Tween(this._goldThing, this.tweens)
                .to({
                    alpha: 0.5
                }, 1000)
                .repeat(Infinity)
                .yoyo(true)
                .easing(P3.utils.TWEEN.Easing.Linear.None);

            this._goldThing._rotateTween = new P3.utils.TWEEN.Tween(this._goldThing, this.tweens)
                .to({
                    rotation: common.deg2rad(-10)
                }, 5000)
                .repeat(Infinity)
                .yoyo(true)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

            this._goldThing._popIn = new P3.utils.TWEEN.Tween(this._goldThing.scale, this.tweens)
                .to({
                    x:0.9, y:0.9
                }, 100)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onComplete(()=>{
                    this._particleEmitter.play();
                    if(this._heartsEmitter)
                        this._heartsEmitter.play();
                });
            this._goldThing._popIn.chain(this._goldThing._shimmerTween, this._goldThing._rotateTween);
        //}

        this._allCookieContainer = new PIXI.Container();
        this._gameContainer.addChild(this._allCookieContainer);

        for (let i = 0; i < 3; i++) {
            let cookieContainer = new PIXI.Container();

            if(i === 2){
                this._allCookieContainer.addChild(cookieContainer);

            }else{
                this._allCookieContainer.addChildAt(cookieContainer, 0);
                cookieContainer.scale.set(0.7);
            }

            let bgCookie = new PIXI.Sprite(common.finishedRecipe.shape || P3.assets.texture('cookie_shape_5'));
            bgCookie.anchor.set(0.5);
            bgCookie.scale.set(0.64);
            bgCookie.position.set(0, -100);
            cookieContainer.addChild(bgCookie);


            //recreate cookie from previous scene
            let recipeContainer = new PIXI.Container();
            recipeContainer.position.set(0, -100);
            cookieContainer.addChild(recipeContainer);

            let cookieImage = new PIXI.Container();
            recipeContainer.addChild(cookieImage);

            let decoratedCookie = new PIXI.Sprite(common.finishedRecipe.shape || P3.assets.texture('cookie_shape_5'));
            decoratedCookie.anchor.set(0.5);
            cookieImage.addChild(decoratedCookie);

            if(common.doughIngredient){

                let determineIng = ()=>{
                    let colour = common.doughIngredient;
                    //console.log(colour);
                    let map = new Map();
                    map.set('ing_white_choc', Dough.WHITE);
                    map.set('ing_dark_choc', Dough.DARK);
                    map.set('ing_rasins', Dough.RAISEN);
                    map.set('ing_strawberries', Dough.STRAWBERRY);

                    let col = null;
                    map.forEach((v,k) => {
                        if(v === colour.toString()){
                            col = k;
                        }
                    });
                    return col;
                };
                const ingOverlay = new PIXI.Sprite(P3.assets.texture(determineIng() + "_cookie_texture"));
                ingOverlay.anchor.set(0.5);
                ingOverlay.scale.set(0.8);
                cookieImage.addChild(ingOverlay);
            }

            let cookieMask = new PIXI.Sprite(common.finishedRecipe.mask || P3.assets.texture('mask_dough_shape_1'));
            cookieMask.anchor.set(0.5);
            cookieMask.width = decoratedCookie.width - 25;
            cookieMask.height = decoratedCookie.height - 30;
            recipeContainer.addChild(cookieMask);

            cookieImage.mask = cookieMask;

            for (let i = 0; i < common.finishedRecipe.children.length; i++) {
                let child = common.finishedRecipe.children[i];
                let sprite = new PIXI.Sprite(child.texture);
                sprite.anchor.set(0.5);
                sprite.position.set(child.position.x, child.position.y);
                cookieImage.addChild(sprite);
            }
            recipeContainer.scale.set(0.7);

            this._cookies.push(cookieContainer);
        }

        this._allCookieContainer.scale.set(0);
        this._allCookieContainer.y += 100;
        this._allCookieContainer.x += 100;
    }

    createFrameUI(){
        this._frame = new PIXI.Sprite(P3.assets.texture('photo_frame'));
        this._frame.anchor.set(0.5);
        this._frame.position.set(common.STAGE_WIDTH * 0.5 + 20, common.STAGE_HEIGHT * 0.5);
        this._frame.visible = false;
        this.addChild(this._frame);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_large_off");
        states.over = P3.assets.texture("btn_primary_large_over");
        states.down = P3.assets.texture("btn_primary_large_down");
        states.icon = P3.assets.texture("icon_download_off");

        this._downloadButton = new P3.Button(states);
        this._downloadButton.visible = false;
        this.addChild(this._downloadButton);

        this._downloadButton.signals.down.add(this.onDownloadButtonClick, this);


        states.icon = P3.assets.texture("icon_play_large_off");

        this._continueButton = new P3.Button(states);
        this._continueButton.visible = false;
        this.addChild(this._continueButton);

        this._continueButton.signals.down.add(this.onContinueButtonClick, this);

        states.icon = P3.assets.texture("icon_previous_off");

        this._retakeButton = new P3.Button(states);
        this._retakeButton.visible = false;
        this.addChild(this._retakeButton);

        this._retakeButton.signals.down.add(this.onRetakeButtonClick, this);
    }

    animateInFrame(){
        let self = this;
        this._downloadButton.scale.set(0);
        new P3.utils.TWEEN.Tween(this._downloadButton.scale, this.tweens)
            .to({
                x: .6,
                y: .6
            }, 340)
            .easing(P3.utils.Easing.Back3.Out)
            .delay(200)
            .onStart(function () {
                self._downloadButton.visible = true;
            })
            .start();

        this._continueButton.scale.set(0);
        new P3.utils.TWEEN.Tween(this._continueButton.scale, this.tweens)
            .to({
                x: .6,
                y: .6
            }, 340)
            .easing(P3.utils.Easing.Back3.Out)
            .delay(200)
            .onStart(function () {
                self._continueButton.visible = true;
            })
            .start();

        this._retakeButton.scale.set(0);
        new P3.utils.TWEEN.Tween(this._retakeButton.scale, this.tweens)
            .to({
                x: .6,
                y: .6
            }, 340)
            .easing(P3.utils.Easing.Back3.Out)
            .delay(200)
            .onStart(function () {
                self._retakeButton.visible = true;
            })
            .start();
    }

    addCharacters(){

        this._t = new PIXI.Container();
        this._t.x = common.STAGE_WIDTH * 0.5;
        this._t.y = common.STAGE_HEIGHT * 0.5;
        this.addChild(this._t);

        this._gameContainer = new PIXI.Container();
        this._t.addChild(this._gameContainer);

        this._bk = new PIXI.Sprite(P3.assets.texture('bg_intro'));
        this._bk.anchor.set(0.5);
        this._bk.width = 1900;
        //this._bk.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this._gameContainer.addChild(this._bk);

        if (common.finishedRecipe){
            this.recreateCookie();
        }

        this._secondaryCharacter = new PIXI.Sprite(common.selectedCharacter._charTexture);
        this._secondaryCharacter.anchor.set(0.5);
        this._secondaryCharacter.position.set(-900, this.getCharacterPosition());
        this._secondaryCharacter.scale.set(1.1);

        this._gameContainer.addChild(this._secondaryCharacter);
        this.animateSecondaryCharacter(this._secondaryCharacter);

        this._dorothy = new Dorothy();
        this._dorothy.scale.set(0.85);
        this._dorothy.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 + 300, 325);
        this._gameContainer.addChild(this._dorothy);
        this.slideInDorothy();
    }

    slideInDorothy(){
        new P3.utils.TWEEN.Tween(this._dorothy, this.tweens)
            .to({
                x: 310
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Linear.None)
            .onStart(() => {
                this._dorothy.playPhotoEnterAnimation();
                P3.audio.playSound("sfx_dorothy_jump_in_00");
            })
            .onComplete(()=>{
                this.animateCookie();
            })
            .start();
    }

    animateSecondaryCharacter(character){
        let breath = SecondaryCharacter.BREATH(this.tweens, character);
        character._breathIn = breath.in;
        character._breathOut = breath.out;
        character._slideIn = SecondaryCharacter.SLIDE_IN(this.tweens, character._slideInAmount, character);
        character._slideIn.onComplete(()=>{
            if(common.selectedCharacter._requestCompleted){
                let particles = ParticleEmitter.LOVE_HEARTS;
                this._heartsEmitter = new ParticleEmitter(particles, ParticleEmitter.HEARTS, false);
                let config = this._heartsEmitter._config;
                config.scale = {
                    "start": 0.2,
                    "end": 0.8,
                    "minimumScaleMultiplier": 0.7
                };
                this._heartsEmitter.overrideDefaultConfig(config);

                this._heartsEmitter.position.set(0, 0);
                this._secondaryCharacter.addChild(this._heartsEmitter);
                this._heartsEmitter.enableLoop();
                this._heartsEmitter.scale.set(0.8);
            }
        });
        character._slideIn.chain(character._breathIn);
        character._slideIn.start();
    }

    createPoseButtons(){
        let newButton = (animationID, textures) =>{
            let state = new P3.ButtonStates();
            state.normal = P3.assets.texture(textures.normal);
            state.over = P3.assets.texture(textures.over);
            state.down = P3.assets.texture(textures.down);
            state.icon = P3.assets.texture(textures.icon);

            let button = new P3.Button(state);
            button._animationID = animationID;
            button.signals.click.add(()=>{
                if(this._tutorialFinger != null){
                    this.removeChild(this._tutorialFinger);
                    this._tutorialFinger.destroy();
                    this._tutorialFinger = null;
                }
                this.onPoseButtonClick(button);
            }, button);

            return button;
        };


        let offsetX = common.STAGE_WIDTH * 0.5 - 150;
        let icons = [
            "icon_pose_002_off",
            "icon_pose_001_off",
            "icon_pose_004_off"
        ];

        for (let i = 0; i < 3; i++) {
            let btn = newButton(i + 1, {
                normal: "btn_primary_small_off",
                over: "btn_primary_small_over",
                down: "btn_primary_small_down",
                icon: icons[i]
            });
            btn.position.set(offsetX, common.STAGE_HEIGHT * 0.5 + 225);
            btn.visible = false;
            this._poseButtons.push(btn);
            this.addChild(btn);
            offsetX += 150;
        }
    }

    createParticleEmitter(){
        let particles = ParticleEmitter.FINAL_COOKIE_LOOP_00;

        this._particleEmitter = new ParticleEmitter(particles, ParticleEmitter.SPARKLE, true);
        this._particleEmitter.position.set(0, -100);
        this._gameContainer.addChild(this._particleEmitter);
        this._particleEmitter.enableLoop();
        let tempConfig = this._particleEmitter._config;
        tempConfig.spawnCircle = {
            "x": 0,
            "y": 0,
            "r": 300
        }
    }

    animateCookie(){
        let pos = [
            200, -200, 0
        ];
        let time = [
            3000, 4000, 2000
        ];
        let index = 0;

        for(let cookie of this._cookies){
            cookie._up = new P3.utils.TWEEN.Tween(cookie, this.tweens)
                .to({
                    y: "+20"
                }, time[index])
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

            cookie._down = new P3.utils.TWEEN.Tween(cookie, this.tweens)
                .to({
                    y: "-20"
                }, time[index])
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

            cookie._up.chain(cookie._down);
            cookie._down.chain(cookie._up);

            cookie._move = new P3.utils.TWEEN.Tween(cookie, this.tweens)
                .to({
                    x: pos[index],
                    y: 0
                }, 2000)
                .onComplete(()=>{
                    cookie._up.start();
                })
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .start();
            index++;
        }

        this._allCookieContainer._tween1 = new P3.utils.TWEEN.Tween(this._allCookieContainer, this.tweens)
            .to({
                x: 0,
                y: -50
            }, common.getRandomInt(1000,2000))
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();

        this._allCookieContainer._tween2 = new P3.utils.TWEEN.Tween(this._allCookieContainer.scale, this.tweens)
            .to({
                x: .8,
                y: .8
            }, common.getRandomInt(1000,2000))
            .onComplete(()=>{
                if(this._goldThing)
                    this._goldThing._popIn.start();
                else{
                    if(this._heartsEmitter)
                        this._heartsEmitter.play();
                    this._particleEmitter.play();
                }

                P3.audio.playSound('sfx_cookie_finished_00');
            })
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    getCharacterPosition(){
        switch (common.selectedCharacter.getName()) {
            case "Tin Man":
                this._secondaryCharacter._slideInAmount = -310;
                this._secondaryCharacter.scale.set(1.15);
                return 175;
            case "Lion":
                this._secondaryCharacter._slideInAmount = -360;
                return 150;
            case "Scarecrow":
                this._secondaryCharacter._slideInAmount = -310;
                this._secondaryCharacter.scale.set(1.2);
                return 175;
            case "Ozma":
                this._secondaryCharacter._slideInAmount = -310;
                return 175;
        }
    }
}
